import React, { useState } from 'react'
import { useHistory } from 'react-router'
import S3FileUpload from 'react-s3'
//My components
import api from '../../lib/api'
import FormNewPost from '../../Components/FormNewPost'
import ButtonPost from '../../Components/ButtonPost'
import NavNewPost from '../../Components/NavNewPost'
const { REACT_APP_BUCKET_NAME, REACT_APP_REGION, REACT_APP_ACCESS_KEY_ID, REACT_APP_SECRET_ACCESS_KEY } = process.env;



export default function NewPost() {
    const date = new Date()
    let readableDate = date.toDateString().split(" ").slice(1,3).join(" ")
    let publishedAt = date.toISOString()
    const userObject = JSON.parse(localStorage.getItem('user-info'))
    const userID = userObject.id
    let postObject = {
                        published_timestamp: publishedAt,
                        published_at: publishedAt,
                        readable_publish_date: readableDate,
                        user: userID
    }
    const [postData, setPostData] = useState({...postObject})
    const history = useHistory()
    const config = {      
                        bucketName: REACT_APP_BUCKET_NAME,      
                        region: REACT_APP_REGION,      
                        accessKeyId: REACT_APP_ACCESS_KEY_ID,      
                        secretAccessKey: REACT_APP_SECRET_ACCESS_KEY
        }

    const inputHandler = event => {
        const { name, value } = event.target
        setPostData({...postData, [name]:value})
    }

    const uploadHandler = event => {
        console.log(config)
        S3FileUpload.uploadFile(event.target.files[0], config)
        .then((data)=> {
            let imageURL = data.location
            console.log(imageURL)
            setPostData({...postData, cover_image: imageURL})
        })
        .catch( err => {
            alert(err)
        })
    }

    const buttonHandler = async () => {
        // const tagList = postData.tags.split(' ')
        // setPostData({...postData, tag_list: tagList})
        // localStorage.getItem('user-info')
        // const userObject = JSON.parse(localStorage.getItem('user-info'))
        // console.log(userObject.id)
        const result = await api.createPost(postData)
        let postID = result.data.post._id
        history.push(`postdetail/${postID}`)
    }

    

    return (
        <div className="container-fluid">
            <div className="container">
                <div className="row header-nav-container">
                    <NavNewPost/>
                </div>
                <div className="row">
                    <div className="col-lg-1"></div>
                    <div className="col-12 col-md-8 col-lg-8 main-creation-container" >
                        <FormNewPost
                            inputHandler={inputHandler}
                            uploadHandler={uploadHandler}
                        />
                        <ButtonPost
                            buttonHandler={buttonHandler}
                        />
                    </div>
                    <div className="col-md-4 col-lg-3 d-none d-md-block post-aside-container"></div>
                </div>

            </div>
        </div>
    )
}
